const defaultLanguages = {
  ru: {
    ru: "Русский",
    en: "Английский",
    tm: "Туркменский",
  },
  en: {
    ru: "Russian",
    en: "English",
    tm: "Turkmen",
  },
  tm: {
    ru: "Rus dili",
    en: "Iňlis dili",
    tm: "Türkmen dili",
  },
};

export default defaultLanguages;
